module.exports = __webpack_public_path__ + "img/0Q3A5610_L_Foamcore.cdf1305c.jpg";